/**
 * Standaard vormpresets voor de "custom_shape"-optie.
 *
 * Print.com kent zelf alleen de opties "custom_shape_simple" en
 * "custom_shape_complex". De configurator biedt daarbovenop concrete vormen
 * aan als eigen UI-notatie: "custom_shape_simple|shape:<vorm>". Het
 * |shape:-deel gaat nooit naar Print.com (zie normalizeCustomShapeProviderValue
 * in product-configurator.tsx) en dient alleen om de editor te vertellen
 * welke hulplijn te tekenen en, voor de vormen hieronder, welke snijcontour
 * in het geexporteerde bestand komt.
 *
 * WAAROM HIER MAAR TWEE VAN DE OORSPRONKELIJK VIJF PRESETS STAAN
 * ----------------------------------------------------------------
 * De vormpresets waren tot voor kort onbereikbaar door een prijsfout (zie
 * de commit die OPTION_DRIFT voor deze presets oploste), dus niemand kon
 * ooit met een gekozen vorm doorklikken naar de upload. Voordat we een
 * snijcontour meesturen naar Print.com moet die vorm ook kloppen met wat zij
 * onder "custom_shape_simple" verstaan, en dat is met zekerheid alleen vast
 * te stellen via Print.com zelf.
 *
 * Twee onafhankelijke bronnen in onze eigen productdossiers omschrijven
 * "custom_shape_simple" zelf als niet meer dan een contour met hoogstens
 * afgeronde hoeken:
 *   - scripts/upsert-printcom-hd-metal-prints.js: "een gesloten eenvoudige
 *     contourlijn met maximaal 4 afgeronde hoeken"
 *   - scripts/upsert-printcom-door-nameplate.js: de waarde heet er letterlijk
 *     "Afgeronde hoeken"
 * En docs/probo/producten/dot-folie.md (andere leverancier, maar over
 * hetzelfde vak) waarschuwt expliciet dat scherpe hoeken in een cutcontour
 * moeilijk te verwerken zijn en altijd een ronding adviseert.
 *
 * Zeshoek (6 scherpe hoeken), hart (cusp) en ster (10 scherpe punten) passen
 * daar niet bij: dat hoort eerder bij "custom_shape_complex", een aparte,
 * anders geprijsde optie. Zonder een geverifieerd antwoord van Print.com zelf
 * (er was geen API-sleutel beschikbaar om dat na te vragen, zie de
 * projectnotities) blijven die drie hier bewust weg. Liever geen vorm
 * aanbieden dan een vorm die als rechthoek aankomt, of die Print.com als
 * verkeerd geprijsd/afgekeurd bestand terugstuurt.
 *
 * "Rond" heeft twee eigen bevestigingen: wandcirkels (altijd een cirkel)
 * staan in scripts/upsert-printcom-priority-products.js al standaard op
 * custom_shape_simple, en docs/probo/producten/dot-folie.md noemt een ronding
 * juist als de veilige keuze. "Afgeronde hoeken" is exact de eigen
 * omschrijving van custom_shape_simple.
 */

export type StandardShapePresetId = 'round' | 'rounded_corners';

export interface StandardShapePreset {
  value: string;
  label: string;
  shape: StandardShapePresetId;
  description: string;
}

export const STANDARD_CUSTOM_SHAPE_PRESETS: StandardShapePreset[] = [
  {
    value: 'custom_shape_simple|shape:round',
    label: 'Rond',
    shape: 'round',
    description: 'Standaard ronde vorm. Wordt als eenvoudige contourvorm verwerkt.',
  },
  {
    value: 'custom_shape_simple|shape:rounded_corners',
    label: 'Afgeronde hoeken',
    shape: 'rounded_corners',
    description: 'Rechthoekige of vierkante vorm met afgeronde hoeken. Wordt als eenvoudige contourvorm verwerkt.',
  },
];
